// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-2yLVF";
var _4 = "wrapper-2L7qw";
var _5 = "size-2GALH";
var _6 = "prefix-1addJ";
var _7 = "value-2SBOp";
var _8 = "measurement-2JIX1";
var _9 = "hand_luggage_excess-xzAtN";
var _a = "carry_on-ddScK";
var _b = "checked_baggage-UEgWR";
var _c = "small-1YrDN";
var _d = "middle-XDRPM";
var _e = "large-1szr_";
var _f = "real_size-R8MOc";
var _10 = "BaggageExcess-3PG1J";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "wrapper", _5 as "size", _6 as "prefix", _7 as "value", _8 as "measurement", _9 as "hand_luggage_excess", _a as "carry_on", _b as "checked_baggage", _c as "small", _d as "middle", _e as "large", _f as "real_size", _10 as "BaggageExcess" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "wrapper": _4, "size": _5, "prefix": _6, "value": _7, "measurement": _8, "hand_luggage_excess": _9, "carry_on": _a, "checked_baggage": _b, "small": _c, "middle": _d, "large": _e, "real_size": _f, "BaggageExcess": _10 }
